import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4bab4a3c"
var script = {}
import style0 from "@/assets/css/element-m.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/app.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.19_css-loader@6.11.0_webpack@5.101.3__ejs@3.1._a1c31663095b92550c006b421edd4a71/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports